import axios from "axios";

/**
 * Asynchronously validates the provided API key by sending a short chat completion request.
 * 
 * This function creates an axios client with the given API key and optional base URL,
 * then sends a test request to the /chat/completions endpoint. If the request succeeds, the API key is valid.
 * If it fails, an error is thrown.
 * 
 * @param {string} apiKey - The API key to validate.
 * @param {string} [baseURL] - Optional base URL for the API.
 * @param {string} [llmModel] - Optional LLM model to use for validation.
 * @returns {Promise<void>} - Resolves if the API key is valid, otherwise throws an error.
 */
export const validateApiKey = async (apiKey, baseURL, llmModel) => {
  try {
    const instance = axios.create({
      baseURL,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${apiKey}`,
      },
    });

    // Use a minimal chat completion request for validation, expecting the model to just say "Hi" back
    await instance.post("/chat/completions", {
      model: llmModel,
      messages: [
        { role: "system", content: "Only reply with 'Hi'." },
        { role: "user", content: "Say hi." }
      ]
    });

  } catch (error) {
    console.error("Validation failed:", error);
    throw new Error("There was an error validating the API key.");
  }
};
